import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=30454e9a&scoped=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=js"
export * from "./SettingsMenu.vue?vue&type=script&lang=js"
import style0 from "./SettingsMenu.vue?vue&type=style&index=0&id=30454e9a&prod&lang=scss"
import style1 from "./SettingsMenu.vue?vue&type=style&index=1&id=30454e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30454e9a",
  null
  
)

export default component.exports